import { FormItem, Input, Select } from 'components/ui'
import { Field } from 'formik'
import { debounce } from 'lodash'

import React, { useState } from 'react'
import AsyncSelect from 'react-select/async'
import { getCountryList, getStateList } from 'services/cityListService'

const InputField = (props) => {
    const { errors, touched, values } = props
    const [, setCountryListValue] = useState('')
    const [, setStateListValue] = useState('')
    const [selectedState, setSelectedState] = useState(null)
    const handleCountryInputChange = (newValue) => {
        setCountryListValue(newValue)
        return newValue
    }
    const handleStateInputChange = (newValue) => {
        setStateListValue(newValue)
        return newValue
    }
    const loadCountryOptions = debounce(async (inputValue, callback) => {
        try {
            if (inputValue.length > 2) {
                const response = await getCountryList(inputValue)

                const options = response.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                    country_code: item.country_code,
                }))
                callback(options)
            }
        } catch (error) {
            console.error('Error fetching data from the API:', error)
            callback([])
        }
    }, 1000)
    const loadStateOptions = debounce(async (inputValue, callback) => {
        try {
            if (inputValue.length > 2) {
                const response = await getStateList(
                    inputValue,
                    values.country_id
                )
                console.log('responseCity', response.data)
                const options = response.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }))
                callback(options)
            }
        } catch (error) {
            console.error('Error fetching data from the API:', error)
            callback([])
        }
    }, 1000)
    return (
        <div>
            <FormItem
                asterisk
                label="Name"
                invalid={errors.city_name && touched.city_name}
                errorMessage={errors.city_name}
            >
                <Field
                    type="text"
                    autoComplete="off"
                    name="city_name"
                    placeholder="Enter City Name"
                    component={Input}
                />
            </FormItem>
            <FormItem
                asterisk
                label="Country"
                invalid={errors.country_id && touched.country_id}
                errorMessage={errors.country_id}
            >
                <Field name="country_id">
                    {({ field, form }) => (
                        <Select
                            loadOptions={loadCountryOptions}
                            onInputChange={handleCountryInputChange}
                            componentAs={AsyncSelect}
                            placeholder={'Select Country'}
                            noOptionsMessage={(a) =>
                                !a.inputValue
                                    ? 'Type something to search..'
                                    : 'No options'
                            }
                            onChange={(country) => {
                                form.setFieldValue(field.name, country.value)
                                form.setFieldValue(
                                    'country_code',
                                    country.country_code
                                )
                                form.setFieldValue('state_id', '')
                                setSelectedState(null)
                            }}
                        />
                    )}
                </Field>
            </FormItem>
            <FormItem
                // asterisk
                label="State"
                // invalid={errors.state_id && touched.state_id}
                // errorMessage={errors.state_id}
            >
                <Field name="state_id">
                    {({ field, form }) => (
                        <Select
                            isDisabled={values.country_id ? false : true}
                            loadOptions={loadStateOptions}
                            onInputChange={handleStateInputChange}
                            componentAs={AsyncSelect}
                            placeholder={'Select State'}
                            value={selectedState}
                            noOptionsMessage={(a) =>
                                !a.inputValue
                                    ? 'Type something to search..'
                                    : 'No options'
                            }
                            onChange={(state) => {
                                setSelectedState(state)
                                form.setFieldValue(field.name, state.value)
                            }}
                        />
                    )}
                </Field>
            </FormItem>
        </div>
    )
}

export default InputField
